import { ContentBlock, PullQuote } from '@/components/ui/ContentBlock'

export const IntegratedHealthDetails = () => (
  <section className="bg-base-50 py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-5xl px-6">
      <ContentBlock label="01" title="Your Two-Hour Consultation & Bio-Scan">
        <p>Your initial appointment lasts approximately two hours.</p>
        <p>
          During this time, Kandake takes a comprehensive health history, exploring your symptoms,
          previous and current health concerns, diet, lifestyle, sleep, stress, medication and other
          relevant factors.
        </p>
        <p>
          Your Bio-Scan assessment is also carried out, providing an additional broad overview
          across multiple health and nutritional indicators.
        </p>
      </ContentBlock>

      <ContentBlock label="02" title="Your Comprehensive Bio-Scan Report">
        <p>
          You receive the complete 80+ page report generated from your Bio-Scan, including the
          individual readings and reference ranges across the areas assessed.
        </p>
        <p>
          With the Integrated service, however, those findings are not considered in isolation. They
          are reviewed alongside the information gathered during your consultation.
        </p>
      </ContentBlock>

      <ContentBlock label="03" title="Your Integrated Health Report">
        <p>
          Following your appointment, Kandake personally reviews your health history and
          consultation findings alongside the results of your Bio-Scan.
        </p>
        <p>These are brought together in your Instrumental Health Integrated Health Report.</p>
        <p>
          Your report identifies important findings, explores relevant connections across your
          health picture, highlights your individual health priorities and provides personalised
          nutritional and lifestyle recommendations, together with herbal recommendations where
          appropriate.
        </p>
        <p>This allows us to move beyond simply asking:</p>
        <PullQuote>“What has the scan highlighted?”</PullQuote>
        <p>and begin exploring:</p>
        <PullQuote>
          “How does this relate to what you are experiencing, what may be contributing to these
          patterns, and what areas should we prioritise?”
        </PullQuote>
      </ContentBlock>

      <ContentBlock label="04" title="Your Follow-Up Zoom Session">
        <p>
          Once your Integrated Health Report has been completed, you receive a follow-up Zoom
          session with Kandake. During this session, Kandake takes you through your Integrated
          Health Report, explains the findings and recommendations, answers your questions and helps
          you understand your next steps.
        </p>
      </ContentBlock>
    </div>
  </section>
)
